import { memo } from 'react';
import { PrimaryButton, DestructiveButton, BUTTON_SIZES } from 'ui/button';
import { validateFooterChildComponentUpdate } from './ModalConfirmationFooter.utils';
import { ConfirmationPrompt, ModalConfirmationFooterActionButtonProps } from './types';

export const ActionButton: React.FC<ModalConfirmationFooterActionButtonProps> = ({
  id,
  confirmButtonLabel,
  discardButtonLabel,
  promptType,
  onConfirm,
  onDiscard,
  size = BUTTON_SIZES.MEDIUM,
}) => {
  return promptType === ConfirmationPrompt.CONFIRM ? (
    <PrimaryButton data-test={`${id}-confirm-button`} onClick={onConfirm} size={size} type="submit">
      {confirmButtonLabel}
    </PrimaryButton>
  ) : (
    <DestructiveButton data-test={`${id}-discard-button`} onClick={onDiscard} size={size}>
      {discardButtonLabel}
    </DestructiveButton>
  );
};

/**
 * this memoization is necessary due to the animation that runs before the components are unmounted.
 * Without this custom check, we may show the wrong state of the component while the dismount animation runs.
 */
export const ModalConfirmationFooterActionButton = memo(
  ActionButton,
  validateFooterChildComponentUpdate,
);
